export { default } from './DecisionTree.component';
export * from './DecisionTree.component';
